module.exports = __webpack_public_path__ + "static/media/header_03_desktop.8ad52fe7.jpg";